import { PromptRequest } from "../../../types/promptTypes";

type FieldContainerProps = {
  field: PromptRequest;
  children: React.ReactNode;
  renderLabel?: boolean;
};

const FieldContainer = (props: FieldContainerProps) => {
  const { field, renderLabel = true } = props;

  return (
    <div className="mb-4">
      {renderLabel && (
        <label className="block text-sm pb-1 font-light text-text-secondary dark:text-text-secondary-dark">
          {field.label}
        </label>
      )}
      <div
        className={`relative ${
          field.error ? "outline outline-red-500 rounded-sm" : ""
        }`}
      >
        {props.children}
      </div>
      {field.error && (
        <span className="text-sm text-red-500">{field.error}</span>
      )}
    </div>
  );
};

export default FieldContainer;
